import React, { useState, ReactNode } from "react";
import styled from "styled-components";

type TabProps = {
  label: string;
  children: ReactNode;
};

type TabsProps = {
  children: ReactNode;
};

const Tab: React.FC<TabProps> = ({ children }) => {
  return <div>{children}</div>;
};

const Tabs: React.FC<TabsProps> = ({ children }) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index: number) => {
    setActiveTab(index);
  };

  const renderTabs = () => {
    return React.Children.map(children, (child, index) => {
      if (React.isValidElement(child)) {
        return (
          <button
            key={index}
            onClick={() => handleTabClick(index)}
            className={` ${
              activeTab === index ? "tabContent active" : "tabContent"
            }`}
          >
            {child.props.label}
            {/* 커스텀 체크아이콘 */}
            {activeTab === index && (
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_check.svg`}
                alt="체크아이콘"
                className="activeCheckIcon"
              />
            )}
          </button>
        );
      }
      return null;
    });
  };

  const renderActiveTabContent = () => {
    return React.Children.map(children, (child, index) => {
      if (React.isValidElement(child) && index === activeTab) {
        return child;
      }
      return null;
    });
  };

  return (
    <Style>
      <div className="tabWrap">{renderTabs()}</div>
      <div>{renderActiveTabContent()}</div>
    </Style>
  );
};

export { Tabs, Tab };
const Style = styled.div`
  .tabWrap {
    width: 100%;
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    gap: 14px;

    .tabContent {
      width: auto;
      white-space: nowrap;
      padding: 10px 30px;
      border-radius: 50px;
      font-size: 18px;
      font-weight: 400;
      border: 1px solid #c7c7c7;
      color: #646464;
      background: none;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.2);
    }
    .tabContent.active {
      padding: 11px 30px;
      background: #333333;
      color: #fff;
      font-weight: 600;
    }
  }
  .activeCheckIcon {
    display: none;
  }

  @media (max-width: 700px) {
    .tabWrap {
      .tabContent,
      .tabContent.active {
        padding: 10px 17px;
        font-size: 16px;
      }
    }
  }
`;
